import { getAuthAxios } from "@artprov/design-system";
import { errorService } from "../../../common/utils/functions/error.service.js";

export const getMatchingBancario = async (filtros = {}, signal = null) => {
    try {
        const { offset, limit, banco, fechaDesde, fechaHasta, estado, fechaEstadoDesde, fechaEstadoHasta, grupo, search } = filtros;

        const params = new URLSearchParams();

        if (offset !== undefined) params.append('offset', offset);
        if (limit !== undefined) params.append('limit', limit);
        if (banco) params.append('banco', banco);
        if (fechaDesde) params.append('fechaDesde', fechaDesde);
        if (fechaHasta) params.append('fechaHasta', fechaHasta);
        if (estado) params.append('estado', estado);
        if (fechaEstadoDesde) params.append('fechaEstadoDesde', fechaEstadoDesde);
        if (fechaEstadoHasta) params.append('fechaEstadoHasta', fechaEstadoHasta);
        if (grupo) params.append('grupo', grupo);
        if (search?.trim()) params.append('search', search.trim());

        const response = await getAuthAxios("default").get(
            `/matching-bancario?${params}`,
            signal ? { signal } : undefined
        );

        const headers = {
            'x-total-count': response.headers['x-total-count'],
            'x-elements-per-page': response.headers['x-elements-per-page'],
            'x-current-page': response.headers['x-current-page'],
        };

        return {
            registros: response.data.registros || [],
            headers,
        };
    } catch (error) {
        errorService.handleError(error, {
            userMessage: "No pudimos obtener los registros de matching bancario.",
            origen: "getMatchingBancario",
        });
        throw error;
    }
};
